import { transparentize } from 'polished';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { Option } from '../../../../../types/Option';

interface IContainerOption extends Option {
  sidemenu: 'open' | 'closed';
  selected: Option;
}

export const ContainerOption = styled(Link)<IContainerOption>`
  width: ${({ sidemenu }) => (sidemenu === 'open' ? '50px' : '96%')};
  min-height: 50px;
  border-radius: ${({ sidemenu }) => (sidemenu === 'open' ? 5 : 8)}px;
  display: flex;
  align-items: center;
  align-self: center;
  ${({ sidemenu }) =>
    sidemenu === 'open' &&
    css`
      justify-content: center;
    `}
  background-color: ${({ selected, option }) =>
    selected.option === option ? 'rgba(255, 255, 255, 0.12)' : 'transparent'};
  box-shadow: ${({ selected, option }) =>
    selected.option === option ? '0 4px 15px rgba(0, 0, 0, 0.15)' : 'none'};
  margin: 0.2rem auto;
  text-decoration: none;
  transition: 0.3s all;
  @media (max-width: 650px) {
    padding: 0 1rem;
  }
  &:hover {
    background-color: ${({ selected, option }) =>
      selected.option !== option && 'rgba(255, 255, 255, 0.06)'};
  }

  .icon-view {
    transition: 0.3s all;
    min-width: 35px;
    min-height: 30px;
    width: 35px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    img,
    svg {
      min-width: 25px;
      min-height: 25px;
      width: 25px;
      height: 25px;
      transition: 0.3s all;
      @media (max-width: 650px) {
        width: 35px;
        height: 35px;
      }
      ${({ sidemenu }) =>
        sidemenu &&
        css`
          transform: scale(0.6);
        `};
    }
  }

  li {
    display: ${({ sidemenu }) => sidemenu === 'open' && 'none'};
    margin-left: 0.3rem;
    color: ${({ theme }) => theme.COLORS.WHITE};
    font-size: 0.95rem;
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    transition: 0.3s all;
    list-style: none;
    @media (max-width: 850px) {
      font-size: 0.85rem;
    }
    @media (max-width: 650px) {
      font-size: 1rem;
    }
  }
`;
